module.exports = require("@seddi/three/addons/postprocessing/RenderPass.js");